import { Typography } from 'antd'
import React from 'react'
import { ReactComponent as CheckIcon } from '../../assets/svg/24px_check.svg'

const CheckList = ({ options = [] }) => {
  return (
    <ul>
      {options.map((option, index) => (
        <li key={`option_${index}`} style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}>
          <div style={{
            marginRight: 8
          }}>
            <CheckIcon fill='red' />
          </div>
          <Typography.Paragraph strong>{option}</Typography.Paragraph>
        </li>
      ))}
    </ul>
  )
}

export default CheckList